/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
// import moment from 'moment';

export const attachPropertyStatusAndNextService = ({ property }) => {
  const { is_active, schedules, active_mowing_schedule_id } = property;

  let mowingSchedule;

  if (!is_active) {
    return { status: 'Inactive', class: 'inactive', nextMow: null };
  }

  if (_.size(schedules)) {
    mowingSchedule = _.find(schedules, (schedule) => {
      return schedule.schedule_id === active_mowing_schedule_id;
    });

    if (mowingSchedule && mowingSchedule.is_paused) {
      return {
        status: 'Paused',
        class: 'paused',
        nextMow: mowingSchedule.next_starts_at,
      };
    }

    if (mowingSchedule && mowingSchedule.status === 'cancelled') {
      return {
        status: 'Cancelled',
        class: 'cancelled',
        nextMow: mowingSchedule.next_starts_at,
      };
    }

    return { status: 'Active', class: 'active', nextMow: mowingSchedule.next_starts_at };
  }

  return { status: 'N/A', class: 'n/a', nextMow: 'N/A' };
};
